import gql from 'graphql-tag';

import { SESSION_USER_FIELDS } from 'app/shared/graphql/sessions/queries';

export const CREATE_ORDER = gql`
  mutation createOrder(
    $billingRegion: String!
    $stripePaymentId: String!
    $eventId: Int!
    $numTickets: Int!
    $promoCodeCode: String
    $isVisaFreeTicketRedeemed: Boolean
    $checkoutVersion: Int!
    $isExpressCheckout: Boolean
    $guestUserId: Int
  ) {
    createOrder(
      billingRegion: $billingRegion
      stripePaymentId: $stripePaymentId
      eventId: $eventId
      numTickets: $numTickets
      promoCodeCode: $promoCodeCode
      isVisaFreeTicketRedeemed: $isVisaFreeTicketRedeemed
      checkoutVersion: $checkoutVersion
      isExpressCheckout: $isExpressCheckout
      guestUserId: $guestUserId
    ) {
      id
      externalConfirmationId
      eventAttendee {
        id
        ticketsCount
        user {
          ...SessionUserFields
          lastAuthMethod
          resetPasswordToken
        }
      }
    }
  }
  ${SESSION_USER_FIELDS}
`;
